console.log(process.env.VUE_APP_BASE_URL)
export default {

    'UnifiedLogin':'yv2/token/UnifiedLogin',  //登录
    'GetUserInfoByUserId': 'yv2/api/GetUserInfoByUserId', // token取用户信息

    getWxJsApi : 'https://mm.sciconf.cn/ajax/get-weixin-jsapi',

    getMeetingInfo : 'seat/hall/meeting',

    // 会场相关
    getHall : 'seat/hall/hall',                     //获取会场列表
    createUpdateHall : 'seat/hall/create-update',   //添加编辑会场
    delHall : 'seat/hall/del',                      //删除会场

    // 其他设置
    createUpdateSetting : 'seat/config/create-update',//其他设置更新于新增
    getSetting:'seat/config/config',                 //获取其他设置
    uploadImage:process.env.VUE_APP_BASE_URL+'seat/config/upload-image',          //上传 
    updateLanguage : '/seat/config/language-create-update', //多语言配置保存或更新
    // 搜索
    search:'seat/user/search',

    // 区域数据
    getLayout:'seat/layout/layout',     // 获取区域内容
    createUpdateLayout:'seat/layout/create-update', // 更新区域
    delLayout:'seat/layout/del',        // 删除布局
    exportLayout:process.env.VUE_APP_BASE_URL+'seat/layout/export',  // 导出座位
    saveSeatLayout:'seat/layout/save-seat',   // 保存座位其他数据
    saveValidLayout:'seat/layout/save-valid', // 设置无效座位
    saveUserSeatLayout:'seat/layout/save-user-seat', // 设置座位
    updateLayout : 'seat/layout/update-layout',   // 交换座位
    importUser:process.env.VUE_APP_BASE_URL+'seat/layout/import-new', // 一键分座
    layoutSeatUser:'seat/layout/layout-user',     // 座位分配列表
    layoutSeatSort:'seat/layout/order-update-sort',//排序

    // 用户
    createUpdateUser:'seat/user/create-update',   // 修改与新增用户
    insertUser:'seat/layout/insert',              // 插入一个用户
    backRemoveUser:'seat/layout/deleted',         // 删除座位并前移一个座位
    getNotSeatUser:'seat/user/layout-user',       // 未分配座位的用户
    getUserList:'seat/user/user',                 // 所有用户列表
    delUser: 'seat/user/del',                     // 删除用户
    delMoreUser: 'seat/user/del-more',            // 批量删除用户
    downSample:process.env.VUE_APP_BASE_URL+'seat/user/down-sample',           //下载excel上传用户字段
    getUserInfo: 'seat/user/user-info', // 获取人员详细信息

    // 短信相关
    getTag : 'seat/user/tags',           // 替换标签
    getLayout2 : 'seat/user/get-layout', // 回去会场列表
    getNum : 'seat/user/get-num',        // 获取会场区域可发短信人数
    smsSend : 'seat/user/sms-send',      // 发送短信
    smsList : 'seat/user/sms-list',      // 获取短信列表
    getMoney : 'seat/user/money',        // 获取余额
    smsPreview : 'seat/user/sms-preview',// 短信预览
}